import clsx from "clsx";
import { LayoutGrid } from "lucide-react";
import { useFolders } from "@/lib/folders";

/** Chooses the space a chat works in (or none). */
export default function FolderPicker({ value, onChange }: { value: string | null | undefined; onChange: (id: string | null) => void }) {
  const folders = useFolders().data ?? [];
  if (!folders.length && !value) return null;
  return (
    <label
      className={clsx(
        "flex items-center gap-1 rounded-lg px-1.5 py-1 text-sm hover:bg-zinc-100 dark:hover:bg-zinc-800",
        value ? "text-amber-600 dark:text-amber-400" : "text-zinc-500",
      )}
      title="Space"
    >
      <LayoutGrid size={16} className="shrink-0" />
      <select value={value ?? ""} onChange={(e) => onChange(e.target.value || null)} className="max-w-[9rem] truncate bg-transparent outline-none" aria-label="Space">
        <option value="">No space</option>
        {folders.map((f) => (
          <option key={f.id} value={f.id}>
            {f.name}
          </option>
        ))}
      </select>
    </label>
  );
}
